// extracted by mini-css-extract-plugin
export default {"melodyVideo":"mL-z","isFullWidth":"nL-z","landingPageVideo":"oL-z","play":"pL-z","iframeVideo":"qL-z","playHidden":"rL-z","fullwidth":"sL-z"};